module.exports = __webpack_public_path__ + "static/media/11.050793a6.jpeg";